var _defs, _circle, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepInprogress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .golden-stroke { \n        stroke: #F0A500; \n        stroke-width: 10; \n        stroke-linecap: butt; \n        fill: none; \n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#fff",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 10 A 40 40 0 0 1 50 90",
    className: "golden-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 90 A 40 40 0 0 1 50 10",
    className: "golden-stroke",
    strokeDasharray: "10 6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 30 52 L 45 66 L 70 38",
    className: "golden-stroke",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepInprogress);
export default __webpack_public_path__ + "static/media/step-inprogress.53959c49d250e1a2d2f26899ad479665.svg";
export { ForwardRef as ReactComponent };